module.exports = __webpack_public_path__ + "img/lineoneLogo.8560cd4f.jpg";